import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {MoedasModel} from "./moedas.model";
import {MoedasService} from './moedas.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-moedas-form',
  templateUrl: './moedas-form.component.html'
})
export class MoedasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  moeda: MoedasModel = new MoedasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private moedasService: MoedasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      iniciais: ['', [
        Validators.required
      ]],
      iso: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(3)
      ]],
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_moeda'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarMoeda');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarMoeda') : this.func.traduzir('front.cadastrarNovaMoeda');
      }


      if (!id) {
        return;
      }

      this.moedasService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarMoeda')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarMoeda') + ': ' + json.Payload[0].nome;
            }

            this.moeda = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.moedasService.editar(values, values.id);
    } else {
      result = this.moedasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'moedas']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/moedas/moedas-form.component.ts